import { stagedRevisionId } from '../fixture-ids';

// Entity named for its own table (staged_revisions), like pipelineIntegration and
// pipelineSchemaLibrary -- not "pipelineVariable", which is only a descriptive label for the child
// type, never a literal entity string anywhere in the map.
export const stagedRevisionEntries = {
  // AFTER UPDATE only (staged_revisions_audit_log_trigger) -- this action never creates a record.
  // No pipelineId anywhere in this trigger: pipelineName is the ONLY parent reference, and it is
  // foreign (joined through pipeline_integrations -> pipelines), so a pipeline's audit view can
  // only reach these rows through parentNameKeys.
  PIPELINE_VARIABLE_UPDATED: {
    entity: 'stagedRevision',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: false,
    parentNameKeys: [{ key: 'pipelineName', entity: 'pipeline' }],
    foreignDisplayKeys: ['pipelineName'],
    complexKeys: ['pipelineVars'],
  },
};

export const stagedRevisionFixtures = {
  PIPELINE_VARIABLE_UPDATED: {
    action: 'PIPELINE_VARIABLE_UPDATED',
    debugData: {
      id: stagedRevisionId,
      pipelineName: 'Web Analytics',
      pipelineVars: { retries: 3, batchSize: 500 },
      readyForDeploy: true,
    },
  },
};
